import { User } from "firebase/auth";
import { createContext, Dispatch, SetStateAction } from "react";
import { UserMenu } from "../../types/authTypes";
import { TopBar } from "../../types/menuTypes";

interface Context {
  user: User | null | undefined;
  // true zolang Firebase bij het opstarten nog bepaalt of er een sessie is.
  authLoading: boolean;
  userMenu: UserMenu[];
  setUserMenu: Dispatch<SetStateAction<UserMenu[]>>;
  currentUser: string;
  setCurrentUser: Dispatch<SetStateAction<string>>;
  topbar: TopBar | undefined;
  setTopbar: Dispatch<SetStateAction<TopBar | undefined>>;
}

const context = createContext({} as Context);

export default context;
